var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoStarLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4066 10.5303L12.1384 14.6867L8.26861 12.7093C8.0974 12.6218 7.89462 12.6217 7.72329 12.7089L3.85089 14.6811L4.58825 10.5257C4.62349 10.327 4.55655 10.124 4.41007 9.98523L1.3171 7.05575L5.61176 6.45314C5.80568 6.42593 5.97412 6.30581 6.06301 6.13132L8.00288 2.32351L9.93767 6.13394C10.0263 6.30854 10.1946 6.42889 10.3885 6.45637L14.6823 7.06476L11.5855 9.99007C11.4388 10.1286 11.3716 10.3316 11.4066 10.5303Z",
    stroke: "#CBCBCB",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStarLine);
export default __webpack_public_path__ + "static/media/ico-star-line.e00f3371517abbbf5533e97e48c8976a.svg";
export { ForwardRef as ReactComponent };